export const tariffEditStyles = (theme) => ({})
